<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Hủy yêu cầu đặt vé
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Ghi chú" prop="note">
              <el-input
                type="textarea"
                v-model="form.note"
                placeholder="Ghi chú"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="500"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Hủy yêu cầu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
          >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import CustomDialog from "../../common/custom-dialog";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import hcCaseFlightService from "../../../services/maybay/hcCaseFlightService";
import constants from "../../../constants";

export default {
  name: "hc-maybay-cancel-dialog",
  mixins: [handleRequestErrorMixin],
  props: ["isOpen", "id"],
  components: {
    CustomDialog
  },

  data() {
    return {
      rules: {
        note: null
      },
      form: {
        note: null
      },
      hcCaseFight: null
    };
  },

  computed: {},

  watch: {},

  async created() {
    this.initValidationRules();
    await this.loadHcCaseFight();
    this.initFormForEdit();
  },

  methods: {
    initFormForEdit() {
      this.form.note = this.hcCaseFight.note;
    },

    loadHcCaseFight() {
      return hcCaseFlightService
        .findById(this.id)
        .then(response => (this.hcCaseFight = response.data));
    },

    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };
      this.rules.note = [defaultRequiredConstrains];
    },

    validateForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (!valid) {
            this.$message.error("Có lỗi nhập liệu. Vui lòng kiểm tra lại");
          } else {
            resolve();
          }
        });
      });
    },

    convertToSubmitForm() {
      return {
        action: constants.HC_STATE_TO_STATE.ACTION_CODE.MAY_BAY.HUY,
        caseMasterId: this.hcCaseFight.caseMasterId,
        note: this.form.note
      };
    },

    submit() {
      this.$confirm("Bạn chắc chắn muốn hủy yêu cầu này ?", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy bỏ",
        type: "warning"
      }).then(() => {
        this.validateForm()
          .then(() => {
            let submitForm = this.convertToSubmitForm();
            return hcCaseFlightService
              .cancel(submitForm)
              .then(response => response.data);
          })
          .then(hcCaseFlight => {
            this.$message.success(
              errorMessageFilter({
                errorCode: "hcFlight.cancelSuccess"
              })
            );
            this.$emit("cancelSuccess", { result: hcCaseFlight });
          })
          .catch(error => {
            this.commonHandleRequestError(error);
            throw error;
          });
      });
    }
  }
};
</script>

<style type="text/css" scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/vemaybay/hc-maybay-cancel-dialog.vue